export default "__VITE_ASSET__cSevAjlf__"